var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLayer06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.8 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        opacity: .32;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 201.23 101.8 283.46 101.8 28.35 0 0 0 201.23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLayer06);
export default __webpack_public_path__ + "static/media/logoLayer06.ad362b0b32147a18c01076ddfc009c1a.svg";
export { ForwardRef as ReactComponent };